/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to true if you want to use the splash screen.
  useCustomCursor: true, // Change this to false if you want the good'ol cursor
  googleTrackingID: "UA-174238252-2",
};

//Home Page
const greeting = {
  title: "Hello.",
  logo_name: "jeeva.t()",
  nickname: "jeevathangavelss",
  full_name: "Jeeva Thangavel",
  subTitle:
    "Senior Full Stack Engineer with 5+ years of experience designing, building, and scaling distributed production systems serving 500K+ concurrent users. Proficient in React, TypeScript, Python, Node.js, PostgreSQL, Redis, and AWS. Delivered measurable impact: reduced API latency by 35%, improved system maintainability by 40%, and cut infrastructure costs by 30%.",
  resumeLink:
    "https://drive.google.com/file/d/1cQ3Iux5HJ78KAfeC5lkzGU8rA04JFA5B/view?usp=sharing",
  mail: "mailto:jeevathangavelss@gmail.com",
};

const socialMediaLinks = {
  /* Your Social Media Link */
  github: "https://github.com/jeevasakthits",
  linkedin: "https://www.linkedin.com/in/jeeva-thangavel-2020a5149/",
  gmail: "jeevathangavelss@gmail.com",
  gitlab: " ",
  facebook: " ",
  // twitter: "https://twitter.com/jeevathangelss",
  instagram: "https://www.instagram.com/jeeva_uniq_soul/",
};

const skills = {
  data: [
    {
      title: "Full Stack Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Designing, building, and scaling distributed production systems serving 500K+ concurrent users using React, Next.js, Node.js, NestJS, and Python.",
        "⚡ Implementing microservices architecture, event-driven systems, and centralized identity management (OAuth2, SSO, RBAC, JWT) across distributed services.",
        "⚡ Optimizing performance through Redis caching strategies, database indexing, code splitting, and lazy loading — delivering measurable impact: 35% API latency reduction, 30% bundle size decrease.",
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        // {
        //   skillName: "TailwindCSS",
        //   fontAwesomeClassname: "logos:tailwindcss-icon",
        //   style: {
        //     color: "#1572B6",
        //   },
        // },
        {
          skillName: "JavaScript (ES6+)",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#FFFFFF",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "TypeScript",
          fontAwesomeClassname: "simple-icons:typescript",
          style: {
            color: "#3178C6",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },

        {
          skillName: "React Native",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "Node.js",
          fontAwesomeClassname: "simple-icons:nodedotjs",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "NextJS",
          fontAwesomeClassname: "simple-icons:nextdotjs",
          style: {
            color: "#FFFFFF",
            backgroundColor: "#1D1D1D",
            borderRadius: "50%",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "logos:python",
          style: {
            color: "#FFCA28",
          },
        },
        {
          skillName: "PostgreSQL",
          fontAwesomeClassname: "simple-icons:postgresql",
          style: {
            color: "#336791",
          },
        },
        {
          skillName: "MySQL",
          fontAwesomeClassname: "simple-icons:mysql",
          style: {
            color: "#4479A1",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#47A248",
          },
        },
        {
          skillName: "Redis",
          fontAwesomeClassname: "simple-icons:redis",
          style: {
            color: "#DC382D",
          },
        },

        {
          skillName: "Git",
          fontAwesomeClassname: "simple-icons:git",
          style: {
            color: "#E94E32",
          },
        },
        {
          skillName: "AWS",
          fontAwesomeClassname: "simple-icons:amazonaws",
          style: {
            color: "#FF9900",
          },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: {
            color: "#1488C6",
          },
        },
        {
          skillName: "C",
          fontAwesomeClassname: "simple-icons:c",
          style: {
            color: "#E94E32",
          },
        },
      ],
    },

    // {
    //   title: "Cloud Infra-Architecture",
    //   fileName: "CloudInfraImg",
    //   skills: [
    //     "⚡ Certified AWS Developer Associate and Cloud Practioner",
    //     "⚡ Experience working on multiple cloud platforms",
    //     "⚡ Experience hosting and managing web apps on GCP and AWS",
    //     "⚡ Deploying deep learning models on cloud to use on mobile devices",
    //   ],
    //   softwareSkills: [
    //     {
    //       skillName: "GCP",
    //       fontAwesomeClassname: "simple-icons:googlecloud",
    //       style: {
    //         color: "#4285F4",
    //       },
    //     },
    //     {
    //       skillName: "AWS",
    //       fontAwesomeClassname: "simple-icons:amazonaws",
    //       style: {
    //         color: "#FF9900",
    //       },
    //     },
    //     {
    //       skillName: "Netlify",
    //       fontAwesomeClassname: "simple-icons:netlify",
    //       style: {
    //         color: "#38AFBB",
    //       },
    //     },
    //     {
    //       skillName: "Heroku",
    //       fontAwesomeClassname: "simple-icons:heroku",
    //       style: {
    //         color: "#6863A6",
    //       },
    //     },
    //     {
    //       skillName: "Firebase",
    //       fontAwesomeClassname: "simple-icons:firebase",
    //       style: {
    //         color: "#FFCA28",
    //       },
    //     },
    //     {
    //       skillName: "MongoDB",
    //       fontAwesomeClassname: "simple-icons:mongodb",
    //       style: {
    //         color: "#47A248",
    //       },
    //     },
    //     {
    //       skillName: "Docker",
    //       fontAwesomeClassname: "simple-icons:docker",
    //       style: {
    //         color: "#1488C6",
    //       },
    //     },
    //   ],
    // },
    // {
    //   title: "Data Science & AI",
    //   fileName: "DataScienceImg",
    //   skills: [
    //     "⚡ Experience of working with Computer Vision and NLP projects",
    //     "⚡ Certifications by deeplearning.ai and Stanford Online",
    //     "⚡ Experience with 10+ Projects",
    //   ],
    //   softwareSkills: [
    //     {
    //       skillName: "Tensorflow",
    //       fontAwesomeClassname: "logos-tensorflow",
    //       style: {
    //         backgroundColor: "transparent",
    //       },
    //     },
    //     {
    //       skillName: "Keras",
    //       fontAwesomeClassname: "simple-icons:keras",
    //       style: {
    //         backgroundColor: "white",
    //         color: "#D00000",
    //       },
    //     },
    //     {
    //       skillName: "PyTorch",
    //       fontAwesomeClassname: "logos-pytorch",
    //       style: {
    //         backgroundColor: "transparent",
    //       },
    //     },
    //     {
    //       skillName: "Python",
    //       fontAwesomeClassname: "ion-logo-python",
    //       style: {
    //         backgroundColor: "transparent",
    //         color: "#3776AB",
    //       },
    //     },
    //     {
    //       skillName: "Pandas",
    //       fontAwesomeClassname: "simple-icons:pandas",
    //       style: {
    //         backgroundColor: "transparent",
    //         color: "#6E6E6E",
    //       },
    //     },
    //   ],
    // },
  ],
};

const degrees = {
  degrees: [
    {
      title: "Karpagam College of Engineering",
      subtitle: "B.Tech. in Information Technology",
      logo_path: "kce.jpg",
      alt_name: "SETI",
      duration: "2016 - 2020",
      descriptions: [
        "⚡ I have studied core subjects like Data Structures, DBMS, Networking, Security, etc.",
        "⚡ I have also completed various online courses for ML/DS, Web Development, Data Engineering, etc.",
        "⚡ I have implemented several projects based on what I've learnt under my Computer Engineering course. ",
      ],
      website_link: "https://kce.ac.in/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Advanced Data Structures and Algorithms",
      subtitle: "codechef.com",
      logo_path: "dsa.png",
      certificate_link:
        "https://drive.google.com/file/d/1zatfE9-WUOYHgM-kiWx903o13gE-2a7M/view?usp=sharing",
      alt_name: "DSA",
      color_code: "#7A7A7A",
    },
    {
      title: "System Design Fundamentals",
      subtitle: "Online",
      logo_path: "react.png",
      certificate_link: "",
      alt_name: "System Design",
      color_code: "#C5E2EE",
    },
    {
      title: "Advanced React Patterns and Performance Optimization",
      subtitle: "Online",
      logo_path: "react.png",
      certificate_link:
        "https://drive.google.com/file/d/1I9aO1jTIz4clbyFTq0XO07GlZ_nUWCrU/view?usp=sharing",
      alt_name: "React Advanced",
      color_code: "#C5E2EE",
    },
    {
      title: "Modern Application Development",
      subtitle: "NPTEL",
      logo_path: "nptel.png",
      certificate_link:
        "https://drive.google.com/file/d/1YLyGWVgrxjQ6_eKc046a6gBoJPTXtqPI/view?usp=sharing",
      alt_name: "NPTEL",
      color_code: "#ffc475",
    },
    {
      title: "Machine Learning",
      subtitle: "Data Camp",
      logo_path: "data_camp.png",
      certificate_link:
        "https://drive.google.com/file/d/1gQcEl66Syq9ucBY3nEqAPw4Ikg163Hoj/view?usp=sharing",
      alt_name: "ML",
      color_code: "#0C9D5899",
    },
    {
      title: "JavaScript Development",
      subtitle: "Udemy",
      logo_path: "js.png",
      certificate_link:
        "https://drive.google.com/file/d/1TxZXBeOUVycH0Vdc60R_yPrUktAe6n6Y/view?usp=sharing",
      alt_name: "JS",
      color_code: "#F8EFBA",
    },
    // {
    //   title: "Deep Learning Specialization",
    //   subtitle: "deeplearning.ai",
    //   logo_path: "deeplearning_ai_logo.png",
    //   certificate_link:
    //     "https://coursera.org/share/737a9587023c666b8e6cb303157aaeba",
    //   alt_name: "deeplearning.ai",
    //   color_code: "#47A048",
    // },
    // {
    //   title: "Sequence Models",
    //   subtitle: "deeplearning.ai",
    //   logo_path: "deeplearning_ai_logo.png",
    //   certificate_link:
    //     "https://www.coursera.org/account/accomplishments/verify/FM5AKEZA9NUY",
    //   alt_name: "deeplearning.ai",
    //   color_code: "#F6B808",
    // },
    // {
    //   title: "Convolutional Neural Networks",
    //   subtitle: "deeplearning.ai",
    //   logo_path: "deeplearning_ai_logo.png",
    //   certificate_link:
    //     "https://www.coursera.org/account/accomplishments/verify/U8BLDNUT9UUM",
    //   alt_name: "deeplearning.ai",
    //   color_code: "#2AAFED",
    // },
    // {
    //   title: "Structuring Machine Learning Projects",
    //   subtitle: "deeplearning.ai",
    //   logo_path: "deeplearning_ai_logo.png",
    //   certificate_link:
    //     "https://www.coursera.org/account/accomplishments/verify/YLC25SJQKH3Y",
    //   alt_name: "deeplearning.ai",
    //   color_code: "#E2405F",
    // },
    // {
    //   title: "Machine Learning",
    //   subtitle: "deeplearning.ai",
    //   logo_path: "stanford_logo.png",
    //   certificate_link:
    //     "https://www.coursera.org/account/accomplishments/records/72KY93DT82MP",
    //   alt_name: "Stanford University",
    //   color_code: "#8C151599",
    // },
    // {
    //   title: "Neural Networks and Deep Learning",
    //   subtitle: "deeplearning.ai",
    //   logo_path: "deeplearning_ai_logo.png",
    //   certificate_link:
    //     "https://www.coursera.org/account/accomplishments/records/25JXRB2RWHRX",
    //   alt_name: "Google",
    //   color_code: "#7A7A7A",
    // },
    // {
    //   title: "Improving Deep Neural Networks",
    //   subtitle: "deeplearning.ai",
    //   logo_path: "deeplearning_ai_logo.png",
    //   certificate_link:
    //     "https://www.coursera.org/account/accomplishments/records/PKR9M9LQ3JWC",
    //   alt_name: "Google",
    //   color_code: "#0C9D5899",
    // },
    // {
    //   title: "Android Developer Nanodegree",
    //   subtitle: "Part of Google India Scholarship Program",
    //   logo_path: "100.png",
    //   certificate_link: "https://graduation.udacity.com/confirm/HLE7K5V3",
    //   alt_name: "Google",
    //   color_code: "#C5E2EE",
    // },
    // {
    //   title: "InOut 4.0 Winner #2",
    //   subtitle: "2017",
    //   logo_path: "ino.png",
    //   certificate_link: " ",
    //   alt_name: "InOut",
    //   color_code: "#fffbf3",
    // },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work, Internship and Volunteership",
  description:
    "Senior Full Stack Engineer with 5+ years of experience designing, building, and scaling distributed production systems. Led cross-functional architectural modernization initiatives, mentored engineering teams, and drove technical roadmaps aligned with business OKRs. Passionate about performance engineering, scalable microservices, and data-driven decision-making.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Experience",
      experiences: [
        {
          title: "Senior Software Engineer (Technical Lead)",
          company: "Recode Solutions",
          company_url: "https://www.recodesolutions.com/",
          logo_path: "recode.jpg",
          duration: "March 2023 - Present",
          location: "Chennai, India",
          description: (
            <ul>
              <li>
                Improved system maintainability by 40% and reduced production
                defects by 30% by leading end-to-end architectural modernization
                of DWAAS platform (React, Python, PostgreSQL), achieving 99.5%
                uptime SLA across services handling 50K+ daily requests.
              </li>
              <li>
                Reduced p95 API response time by 35% and lowered database query
                load by 25% by designing a Redis caching layer with TTL
                policies, cache invalidation, and circuit-breaker fallback
                mechanisms, serving 500K+ monthly active users.
              </li>
              <li>
                Eliminated duplicated authentication logic across 8+
                microservices by architecting a centralized identity management
                system (OAuth2, SSO, RBAC, JWT), reducing auth-related incidents
                by 30% and improving developer onboarding time.
              </li>
              <li>
                Decreased frontend bundle size by 30% and improved Largest
                Contentful Paint by 20% by migrating legacy class-based React
                components to functional architecture with hooks, lazy loading,
                and code splitting.
              </li>
              <li>
                Increased team velocity by 25% by mentoring 3+ engineers on
                system design, code review best practices, and architectural
                patterns; established team coding standards and technical
                documentation processes.
              </li>
              <li>
                Drove technical roadmap and presented architectural decisions to
                C-level stakeholders, aligning engineering priorities with
                business OKRs and long-term scalability goals.
              </li>
              <li>
                Skills: React, Python, Node.js, NestJS, PostgreSQL, Redis,
                OAuth2, SSO, JWT, RBAC, Docker, AWS, System Design.
              </li>
            </ul>
          ),
          color: "#f10000",
        },
        {
          title: "Full Stack Engineer",
          company: "Byjus (Ed-Tech, 2M+ Users)",
          company_url: "https://byjus.com/",
          logo_path: "byjus.png",
          duration: "November 2021 - March 2022",
          location: "Bangalore, India",
          description: (
            <ul>
              <li>
                Boosted student engagement by 35% across 2M+ monthly active
                users by designing and developing 40+ TypeScript-based
                interactive animation templates using React, GSAP, and Canvas
                API for digital learning modules.
              </li>
              <li>
                Reduced manual data processing time by 60% and improved
                accuracy by 40% by building a full-stack evaluation platform
                (Python Django REST, React, PostgreSQL) adopted by 150+ team
                members.
              </li>
              <li>
                Improved First Contentful Paint by 25% and boosted organic
                search traffic by leading React-to-Next.js migration for 5
                production applications, implementing SSR, ISR, and static
                generation with optimized Core Web Vitals.
              </li>
              <li>
                Enabled real-time data-driven decision making by developing an
                end-to-end auditing portal (Python, React, Chart.js, D3.js,
                PostgreSQL) with interactive dashboards and automated report
                generation.
              </li>
              <li>
                Achieved 99.9% event processing reliability handling 10K+ daily
                async events by implementing AWS SQS and Lambda for decoupled
                task processing, reducing API response times by 40%.
              </li>
              <li>
                Skills: TypeScript, React, Next.js, GSAP, Canvas API, Python,
                Django REST, PostgreSQL, AWS SQS, AWS Lambda, D3.js, Chart.js.
              </li>
            </ul>
          ),
          color: "#2962FF",
        },
        {
          title: "Frontend Engineer",
          company: "PurpleSlate Pvt Ltd",
          company_url: "https://www.purpleslate.com/",
          logo_path: "prpleslate.png",
          duration: "July 2020 - November 2021",
          location: "Chennai, India",
          description: (
            <ul>
              <li>
                Owned 50% of frontend codebase for an enterprise insurance
                platform serving 500+ concurrent users; managed client
                communication, sprint planning, and delivered all features on
                schedule with zero critical defects.
              </li>
              <li>
                Enabled 500+ employees to transition to remote work by building
                an OAuth2-secured analytics dashboard (React, D3.js) with
                real-time KPI tracking, increasing team productivity by 40%
                during pandemic transition.
              </li>
              <li>
                Improved page load times by 30% by migrating 20+ legacy
                jQuery/Vanilla JS pages to modern React.js with component-based
                architecture, reducing codebase complexity and improving
                developer velocity.
              </li>
              <li>
                Reduced feature delivery time by 25% by creating a reusable
                component library with Storybook documentation, establishing
                design system standards adopted across 3 engineering teams.
              </li>
              <li>Skills: React.js, D3.js, OAuth2, MySQL, Strapi, Gatsby.</li>
            </ul>
          ),
          color: "#2962FF",
        },
      ],
    },
    {
      title: "Internships",
      experiences: [
        {
          title: "NLP/ML Engineer Intern",
          company: "Embibe",
          company_url: "https://www.embibe.com/",
          logo_path: "embibe.png",
          duration: "August 2019 - June 2020",
          location: "Bangalore, India",
          description: (
            <ul>
              <li>
                Improved data extraction efficiency by 50% and reduced manual
                intervention by 70% by developing a Python NLP pipeline
                (BeautifulSoup, NLTK, custom algorithms) to extract translated
                language pairs from 500+ NCERT PDFs.
              </li>
              <li>
                Eliminated ₹13 lakhs in annual operational costs by automating
                word pair and sentence pair generation using Python ML
                techniques, reducing processing time from months to days.
              </li>
              <li>
                Generated 3M+ multilingual sentence pairs across 6 languages
                using Scrapy and NLP-based PDF extraction, improving machine
                translation model accuracy by 15%.
              </li>
              <li>
                Skills: Python, NLTK, BeautifulSoup, Scrapy, Natural Language
                Processing, Data Mining.
              </li>
            </ul>
          ),
          color: "#0071C5",
        },
        {
          title: "Machine Learning Internship NLP",
          company: "ZOHO Corporation",
          company_url: "https://www.zoho.com/",
          logo_path: "zoho.png",
          duration: "May 2019 - June 2019",
          location: "Chennai, India",
          description: (
            <p>
              Developed an ML model for customer recommendation
              <br />
              Developed and ML model for classifying softwares for internal
              usage
              <br />
              <br />
              Skills: Machine Learning, Algorithms, Python
            </p>
          ),
          color: "#0071C5",
        },
      ],
    },
    // {
    //   title: "Volunteerships",
    //   experiences: [
    //     {
    //       title: "Google Summer of Code Mentor",
    //       company: "Sugar Labs / GSoC",
    //       company_url: "https://sugarlabs.org/",
    //       logo_path: "google_logo.png",
    //       duration: "Summer of 2017 / 18 / 20",
    //       location: " ",
    //       description:
    //         "Mentorship responsibilities were to help students plan the project, review issues and pull requests, ensure smooth progress and help them out when they are stuck.",
    //       color: "#4285F4",
    //     },
    //     {
    //       title: "Google Code-In Mentor",
    //       company: "Sugar Labs / GSoC",
    //       company_url: "https://sugarlabs.org/",
    //       logo_path: "google_logo.png",
    //       duration: "Winter of 2017 / 18 / 19",
    //       location: " ",
    //       description:
    //         "Day to day resposibilites of this mentorship was to help out children aged 13-17 get started with programming and open-source, review their work and approve them.",
    //       color: "#D83B01",
    //     },
    //     {
    //       title: "Board Member at Codeuino",
    //       company: " ",
    //       company_url: " ",
    //       logo_path: "codeuino.jpg",
    //       duration: "2018 - 2019",
    //       location: " ",
    //       description: "Previous Board during early days of Codeuino",
    //       color: "#D83B01",
    //     },
    //     {
    //       title: "BluWings Club",
    //       company: " ",
    //       company_url: " ",
    //       logo_path: "b.png",
    //       duration: "2018 - On Going",
    //       location: " ",
    //       description:
    //         "Co-Founder and President of the programming club called BluWings. Have organized several workshops which introduced programming and related tools to freshers.",
    //       color: "#D83B01",
    //     },
    //   ],
    // },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects makes use of latest technology tools. My best experience is to create Front End projects. Below are some of my projects. Note that not all of the mentioned projects are on GitHub yet.",
  avatar_image_path: "projects_image.svg",
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "jeevat.png",
    description:
      "You can contact me at the places mentioned below. I will try to get back to you as fast as I can. ",
  },
  blogSection: {
    title: "Blogs",
    subtitle:
      "I don't blog frequently but when I do something awesome, I do try my best to write a blog about it.",
    link: "",
    avatar_image_path: "blogs_image.svg",
  },
};

const projects = {
  data: [
    {
      name: "DWAAS Platform Modernization",
      url: "",
      description:
        "Led full-stack re-architecture of a legacy monolith into modular microservices. Designed API contracts, database migration strategy, and caching layer serving 500K+ users with 99.5% uptime.",
      languages: [
        {
          name: "React",
          iconifyClass: "logos-react",
        },
        {
          name: "Python",
          iconifyClass: "logos-python",
        },
        {
          name: "Redis",
          iconifyClass: "simple-icons:redis",
        },
        {
          name: "PostgreSQL",
          iconifyClass: "simple-icons:postgresql",
        },
        {
          name: "Docker",
          iconifyClass: "simple-icons:docker",
        },
      ],
    },
    {
      name: "Centralized Identity & Access Management",
      url: "",
      description:
        "Architected a unified authentication service consolidating 8+ disparate auth implementations into a single, secure, horizontally scalable identity platform with <200ms token validation latency.",
      languages: [
        {
          name: "OAuth2",
          iconifyClass: "simple-icons:openid",
        },
        {
          name: "JWT",
          iconifyClass: "simple-icons:jsonwebtokens",
        },
        {
          name: "Node.js",
          iconifyClass: "simple-icons:nodedotjs",
        },
        {
          name: "PostgreSQL",
          iconifyClass: "simple-icons:postgresql",
        },
      ],
    },
    {
      name: "Dynamic Animation Template Platform",
      url: "",
      description:
        "Built an end-to-end dynamic animation platform using Python, React, D3.js, GSAP, Chart.js, and PostgreSQL for real-time interactive learning and concept visualization for 2M+ users.",
      languages: [
        {
          name: "React",
          iconifyClass: "logos-react",
        },
        {
          name: "TypeScript",
          iconifyClass: "simple-icons:typescript",
        },
        {
          name: "GSAP",
          iconifyClass: "",
        },
        {
          name: "Python",
          iconifyClass: "logos-python",
        },
        {
          name: "PostgreSQL",
          iconifyClass: "simple-icons:postgresql",
        },
      ],
    },
    {
      name: "Enterprise Insurance Platform",
      url: "",
      description:
        "Owned 50% of frontend codebase for an enterprise insurance platform. Built OAuth2-secured analytics dashboard with real-time KPI tracking and a reusable component library adopted across 3 engineering teams.",
      languages: [
        {
          name: "React.js",
          iconifyClass: "logos-react",
        },
        {
          name: "D3.js",
          iconifyClass: "simple-icons:d3dotjs",
        },
        {
          name: "MySQL",
          iconifyClass: "simple-icons:mysql",
        },
        {
          name: "Gatsby",
          iconifyClass: "skill-icons:gatsby",
        },
      ],
    },
    {
      name: "Answer Checking System",
      url: "https://github.com/jeevasakthits/Answer_Checking_Systen.git",
      description:
        "It checks answers based on the paragraph matching level, and provides us the scores",
      languages: [
        {
          name: "Python",
          iconifyClass: "logos-python",
        },
      ],
    },
    {
      name: "Stock Recommender",
      url: "https://github.com/jeevasakthits/Stock_Recommendation.git",
      description:
        "This dashboard will suggest us best algorithm for forecasting stock market based on the given stock data",
      languages: [
        {
          name: "Python",
          iconifyClass: "logos-python",
        },
        {
          name: "Flask",
          iconifyClass: "simple-icons:flask",
        },
        {
          name: "HTML",
          iconifyClass: "simple-icons:html5",
        },
        {
          name: "CSS",
          iconifyClass: "fa-css3",
        },
      ],
    },

    // {
    //   name: "Doorbell.io",
    //   url: "https://github.com/jeevathangavelss/Doorbell.io",
    //   description:
    //     "A sound-classifier webapp made with ReactJS + TensorflowJS.",
    //   languages: [
    //     {
    //       name: "Python",
    //       iconifyClass: "logos-python",
    //     },
    //     {
    //       name: "ReactJS",
    //       iconifyClass: "logos-react",
    //     },
    //     {
    //       name: "TensorflowJS",
    //       iconifyClass: "logos-tensorflow",
    //     },
    //   ],
    // },
    // {
    //   name: "Video Summarization",
    //   url: "https://github.com/jeevathangavelss/Video-Summarization",
    //   description:
    //     "A video summarization webapp. A Flask-based backend which servers the Tensorflow model and a frontend made in ReactJS.",
    //   languages: [
    //     {
    //       name: "JavaScript",
    //       iconifyClass: "logos-javascript",
    //     },
    //     {
    //       name: "Python",
    //       iconifyClass: "logos-python",
    //     },
    //     {
    //       name: "ReactJS",
    //       iconifyClass: "logos-react",
    //     },
    //     {
    //       name: "Tensorflow",
    //       iconifyClass: "logos-tensorflow",
    //     },
    //   ],
    // },
    // {
    //   name: "Dashboard Activity",
    //   url: "https://github.com/jeevathangavelss/Dashboard.activity",
    //   description:
    //     "Google Summer of Code project. A Dashboard activity for Sugar OS which tracks user activity so user can know where they use their most time and where they create most files.",
    //   languages: [
    //     {
    //       name: "Python",
    //       iconifyClass: "logos-python",
    //     },
    //   ],
    // },
    // {
    //   name: "Project Pickle",
    //   url: " ",
    //   description:
    //     "An app similar to Uber Eats but targeted for Gruhudhyogs (homemade pickles and products). Order management, live order tracking, rating and reviews system, etc.",
    //   languages: [
    //     {
    //       name: "Java",
    //       iconifyClass: "logos-java",
    //     },
    //     {
    //       name: "Firebase",
    //       iconifyClass: "logos-firebase",
    //     },
    //     {
    //       name: "Python",
    //       iconifyClass: "logos-python",
    //     },
    //   ],
    // },
    // {
    //   name: "Project Health Card",
    //   url: "",
    //   description:
    //     "An aadhard-card like utility card which keeps track of all your health records suchs as: Medicines, Lab Reports, Recent Diseases, Allergies, etc.",
    //   languages: [
    //     {
    //       name: "JavaScript",
    //       iconifyClass: "logos-java",
    //     },
    //     {
    //       name: "Python",
    //       iconifyClass: "logos-python",
    //     },
    //     {
    //       name: "Firebase",
    //       iconifyClass: "logos-firebase",
    //     },
    //     {
    //       name: "ReactJS",
    //       iconifyClass: "logos-react",
    //     },
    //     {
    //       name: "MongoDB",
    //       iconifyClass: "logos-mongodb",
    //     },
    //   ],
    // },
    // {
    //   name: "Food Classifier",
    //   url: " ",
    //   description:
    //     "A food classifier app using tflite which classfier over 50 Indian Dishes.",
    //   languages: [
    //     {
    //       name: "Flutter",
    //       iconifyClass: "logos-flutter",
    //     },
    //     {
    //       name: "Dart",
    //       iconifyClass: "logos-dart",
    //     },
    //     {
    //       name: "Tensorflow",
    //       iconifyClass: "logos-tensorflow",
    //     },
    //     {
    //       name: "Jupyter Notebook",
    //       iconifyClass: "logos-jupyter",
    //     },
    //   ],
    // },
    // {
    //   name: "Image Clustering",
    //   url: " ",
    //   description:
    //     "A simple use of K-Means Clustering algorithm to sort images by automatically predicting number of classes. This can be used to clean an image dataset.",
    //   languages: [
    //     {
    //       name: "Python",
    //       iconifyClass: "logos-python",
    //     },
    //     {
    //       name: "Jupyter Notebook",
    //       iconifyClass: "logos-jupyter",
    //     },
    //   ],
    // },
    // {
    //   name: "Antivirus",
    //   url: " ",
    //   description:
    //     "A project from 2012. Made an antivirus with realtime scanning. Implemented by using comparison of md5 hashes.",
    //   languages: [
    //     {
    //       name: "Visual Basic",
    //       iconifyClass: "logos-dotnet",
    //     },
    //   ],
    // },
    // {
    //   name: "Sugar on Windows",
    //   url: " ",
    //   description:
    //     "Run and setup Sugar OS to be able to run on Windows using Windows Subsystem for Linux",
    //   languages: [
    //     {
    //       name: "Visual Basic",
    //       iconifyClass: "logos-dotnet",
    //     },
    //     {
    //       name: "Python",
    //       iconifyClass: "logos-python",
    //     },
    //   ],
    // },
    // {
    //   name: "Object + Face Detection",
    //   url: " ",
    //   description: "2017 project. Object detection + accurate face detection.",
    //   languages: [
    //     {
    //       name: "Python",
    //       iconifyClass: "logos-python",
    //     },
    //     {
    //       name: "Tensorflow",
    //       iconifyClass: "logos-tensorflow",
    //     },
    //     {
    //       name: "OpenCV",
    //       iconifyClass: "logos-opencv",
    //     },
    //   ],
    // },
    // {
    //   name: "Image Captioning with Visual Attention",
    //   url: " ",
    //   description: "Ongoing. Used MSCOCO 2014/2017 for image captioning.",
    //   languages: [
    //     {
    //       name: "Python",
    //       iconifyClass: "logos-python",
    //     },
    //     {
    //       name: "Tensorflow",
    //       iconifyClass: "logos-tensorflow",
    //     },
    //     {
    //       name: "Jupyter Notebook",
    //       iconifyClass: "logos-jupyter",
    //     },
    //   ],
    // },
    // {
    //   name: "DalSocial",
    //   url: " ",
    //   description:
    //     "An Android app to meet new people in the university, organize and join events. ",
    //   languages: [
    //     {
    //       name: "Kotlin",
    //       iconifyClass: "simple-icons:kotlin",
    //       color: "#F18E33",
    //     },
    //     {
    //       name: "Android",
    //       iconifyClass: "simple-icons:android",
    //       color: "#3DDC84",
    //     },
    //     {
    //       name: "Firebase",
    //       iconifyClass: "logos-firebase",
    //     },
    //   ],
    // },
    // {
    //   name: "HalifaxFoodie",
    //   url: " ",
    //   description:
    //     "CSCI5410 Project. A multi-client recipe app for Halifax Foodies.",
    //   languages: [
    //     {
    //       name: "ReactJS",
    //       iconifyClass: "logos-react",
    //     },
    //     {
    //       name: "AWS",
    //       iconifyClass: "logos-aws",
    //     },
    //     {
    //       name: "Google Cloud",
    //       iconifyClass: "logos-google-cloud",
    //     },
    //   ],
    // },
  ],
};

export {
  settings,
  greeting,
  socialMediaLinks,
  skills,
  degrees,
  certifications,
  experience,
  projectsHeader,
  contactPageData,
  projects,
};
